import React from "react";

const Header = () => {
	return (
		<div className="headerBar">
			<div className="outer-menu">
				<input className="checkbox-toggle" type="checkbox" />
				<div
					className="hamburger"
					onClick={() => {
						document.querySelector(".checkbox-toggle").click();
					}}
				>
					<div></div>
				</div>
				<div className="menu">
					<div>
						<div className="container">
							<div className="row">
								<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
									<div className="center">
										<ul className="menulinks">
											<li>
												<a href="/#ka-mes-darome">
													Ką mes darome
												</a>
											</li>
											<li>
												<a href="/#musu-klientai">
													Mūsų klientai
												</a>
											</li>
											<li>
												<a href="/portfolio">
													Portfolio
												</a>
											</li>
											<li>
												<a href="/#technologijos">
													Technologijos
												</a>
											</li>
											<li>
												<a href="/#apie-mus">
													Apie mus
												</a>
											</li>
											<li>
												<a href="/#kontaktai">
													Kontaktai
												</a>
											</li>
										</ul>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<a href="/" className="iconLeftStyle">
				<img alt="logo" src={"/skaiciuokle/img/mainLogo.png"} />
			</a>
		</div>
	);
};

export default Header;
